import { Link } from 'react-router-dom';
import VLibras from 'react-vlibras';
import Header from './headerPsicoHumanista'; 
import AboutPsicopedagogia from './AboutPsicoHumanista';
import Psicopedagogia from './CorpoClinicoPsicoHumanista';

const About = () => {
    return (
      <div>
        <Header />
        <VLibras />
        <AboutPsicopedagogia />
        <Psicopedagogia />
      </div>
    );
  };
  
  export default About;
  